import React, {useState, useEffect} from 'react';
import useProps from '../../_util/useProps';
import loadingPng from '../assets/loading.png';
import ItemWrap from "../components/item-wrap";

const Loading = (props) => {
    const {show} = props;
    const [loading, setLoading] = useState(false);

    const { map } = useProps();

    useEffect(() => {
        const loadingChange = e => {
            setLoading(true);
            if (e === 0) {
                setLoading(false);
            }
        };

        map.eventEmitter.on('loading', loadingChange)

        return () => {
            map.eventEmitter.un('loading', loadingChange)
        }
    }, []);

    if (loading && show) {
        return (
            <ItemWrap>
                <img title="地图资源加载中..." src={loadingPng} alt="" style={{width: '80%', height: '80%'}}/>
            </ItemWrap>
        )
    }

    return <></>
}

export default Loading;
